import React from 'react'
import errorIcon from '../../images/error-icon.svg';
import pdfIcon from '../../images/pdf-icon.svg'
import { Link } from 'react-router-dom'
import './verify-failure.style.scss'

export const VerifyFailureComponent = (props) => {

  return (
    <div>
      <img className="error-icon" src={errorIcon} alt=""/>
      <h1 className="error-title">Izvornik dokumenta nije moguće dohvatiti</h1>
      <p className="error-info">
        Pružatelj eUsluge nije omogućio dohvat i provjeru traženog dokumenta ili je istekao period čuvanja dokumenta
      </p>
      <p className="error-info">Ukoliko ste u posjedu izvornika elektronički potpisanog dokumenta, valjanost potpisa dokumenta možete provjeriti klikom na gumb "Validacija"</p>
      <Link className="link-button" to="/validacija">Validacija</Link>
    </div>
  )
}